import { InputEscapeResult, ResponseEscapeResult } from "../Types/api";

export const formatTime = (timeInSeconds: number) => {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = timeInSeconds % 60;
  return `${minutes} minutes ${seconds} seconds`;
};

export const formatTimeNumerical = (timeInSeconds: number) => {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = timeInSeconds % 60;
  return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
};

export const generateRandomRoomVariant = (): 0 | 1 | 2 => {
  return Math.floor(Math.random() * 3) as 0 | 1 | 2;
};

export const nextVariantNoRepeat = (prev: 0 | 1 | 2): 0 | 1 | 2 => {
  let n: 0 | 1 | 2;
  do { n = Math.floor(Math.random() * 3) as 0 | 1 | 2; } while (n === prev);
  return n;
};

export const formatTimeToMinutes = (timeInSeconds: number) => {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = timeInSeconds % 60;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
  return `${minutes}:${formattedSeconds}`;
};

export const isInputEscapeResult = (
  data: unknown
): data is InputEscapeResult[] => {
  return (
    Array.isArray(data) &&
    data.every(
      (item) =>
        typeof item.name === "string" &&
        typeof item.school === "string" &&
        typeof item.timeTaken === "number" &&
        typeof item.room === "string"
    )
  );
};


export const isResponseEscapeResult = (
  data: unknown
): data is ResponseEscapeResult[] => {
  return (
    Array.isArray(data) &&
    data.every(
      (item) =>
        typeof item.name === "string" &&    
        typeof item.event === "string" &&
        typeof item.results === "object" 
)

  );
};

